<template>
  <div>
    <!-- header -->
    <header class="header">
      <!-- main-navbar -->
      <b-navbar
        toggleable="lg"
        class="navbar navbar-expand-lg navbar-dark main-navbar"
      >
        <div class="container">
          <b-navbar-brand href="#">
            <router-link to="/" tag="span">{{ $t("message") }}</router-link>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <router-link
                class="nav-item"
                tag="li"
                active-class="active"
                exact
                to="/"
              >
                <a class="nav-link" href="#">{{ $t("home") }}</a>
              </router-link>

              <router-link
                class="nav-item"
                tag="li"
                active-class="active"
                to="/admin"
              >
                <a class="nav-link" href="#">{{ $t("admin") }}</a>
              </router-link>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto align-items-center">
              <!-- <form class="d-flex search-box m-auto">
                <input
                  class="form-control input"
                  type="search"
                  placeholder="Search"
                  name="serach-value"
                />
                <button class="btn main-btn" type="submit">
                  <i class="fa fa-search"></i>
                </button>
              </form>-->
              <template v-if="!auth">
                <router-link
                  class="nav-item"
                  tag="li"
                  active-class="active"
                  to="/signin"
                >
                  <a class="nav-link" href="#">{{ $t("signin") }}</a>
                </router-link>

                <router-link
                  class="nav-item"
                  tag="li"
                  active-class="active"
                  to="/signup"
                >
                  <a class="nav-link" href="#">{{ $t("signup") }}</a>
                </router-link>
              </template>
              <!-- <select v-model="$i18n.locale" @change="changeLanguage">
                <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
              </select> -->

              <!-- <b-form-select
                v-model="$i18n.locale"
                @change="changeLanguage"
                :options="langs"
                class="w-auto"
              ></b-form-select> -->
              <template v-if="auth">
                <li class="nav-item">
                  <a class="nav-link" href="#" @click.prevent="signOut"
                    >log out</a
                  >
                </li>
              </template>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  @click.prevent="$bvModal.show('cart-modal')"
                >
                  <div
                    class="dropdown-box d-flex flex-column align-items-center justify-content-center cart"
                  >
                    <span class="badge">{{ cartItemsNumber }}</span>
                    <i class="fas fa-shopping-bag"></i>
                  </div>
                </a>
              </li>
            </b-navbar-nav>
          </b-collapse>
        </div>
      </b-navbar>
      <!-- end main-navbar -->
    </header>
    <!-- end header -->
  </div>
</template>

<script>
export default {
  name: "appHeader",
  data() {
    return {
      langs: [
        {
          value: "ar",
          text: this.$t("arabic"),
        },
        {
          value: "en",
          text: this.$t("english"),
        },
      ],
    };
  },
  computed: {
    auth() {
      return this.$store.getters["authModule/getUser"].id
        ? this.$store.getters["authModule/getUser"].id
        : "";
    },
    cartItemsNumber() {
      return this.$store.getters["cartModule/getCartItemsNumber"];
    },
  },
  methods: {
    signOut() {
      this.$store.dispatch("authModule/signOut");
    },
    changeLanguage() {
      console.log(this.$i18n.locale);
      if (this.$i18n.locale == "ar") {
        document.querySelector("body").classList.add("ar");
        document.querySelector("#bootstrap-rtl").removeAttribute("disabled");
        // document.querySelector("#bootstrap-ltr").setAttribute('disabled', '');
        setTimeout(function() {
          document.querySelector("#bootstrap-ltr").setAttribute("disabled", "");
        }, 20);
      } else {
        document.querySelector("body").classList.remove("ar");
        document.querySelector("#bootstrap-ltr").removeAttribute("disabled");
        setTimeout(function() {
          document.querySelector("#bootstrap-rtl").setAttribute("disabled", "");
        }, 20);
      }
    },
  },
  created() {
    document.querySelector("#bootstrap-rtl").setAttribute("disabled", "");
  },
};
</script>
